import { isEqual } from 'es-toolkit';

import { isInteractiveEditActive } from '../selectors/interactiveEditingSelectors';
import { __UNSAFE_setHoverItem, clearHoverItem, HoveredItem, setTooltipHidden_Internal } from '../slices/viewportSlice';
import { ThunkActionVoid } from './thunkActions';

export const ensureHoverItemIsActive =
  (item: HoveredItem): ThunkActionVoid =>
  (dispatch, getState) => {
    const state = getState();
    if (isInteractiveEditActive(state)) return;

    if (state.viewport.hoveredItem?.guid !== item.guid) {
      dispatch(__UNSAFE_setHoverItem(item));
    }
  };

export const clearHoverItemIfActive =
  (item: HoveredItem): ThunkActionVoid =>
  (dispatch, getState) => {
    const state = getState();
    if (isInteractiveEditActive(state)) return;

    if (isEqual(state.viewport.hoveredItem, item)) {
      dispatch(clearHoverItem());
    }
  };

export const setTooltipHidden =
  (hidden: boolean): ThunkActionVoid =>
  (dispatch, getState) => {
    if (getState().viewport.tooltipHidden !== hidden) dispatch(setTooltipHidden_Internal(hidden));
  };
